import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
type CheckListProps = {
  items: string[];
  tone?: 'dark' | 'light';
  columns?: boolean;
};
export function CheckList({
  items,
  tone = 'light',
  columns = false
}: CheckListProps) {
  const isDark = tone === 'dark';
  return <ul className={`grid gap-2.5 ${columns ? 'sm:grid-cols-2' : ''}`} data-id="element-20" data-mp="38nnzcaf81w67">
      {items.map(item => <li key={item} className={`flex items-start gap-2.5 text-[15px] leading-snug ${isDark ? 'text-white/90' : 'text-ink'}`} data-id="element-21" data-mp="33ob534m0tmtl">
          <CheckCircle2Icon className={`mt-0.5 h-5 w-5 shrink-0 ${isDark ? 'text-sky' : 'text-success'}`} aria-hidden="true" data-id="element-22" data-mp="2ywtdh75w0yla" />
          <span data-id="element-23" data-mp="2tz1clnn9m24y">{item}</span>
        </li>)}
    </ul>;
}